import React, { Component } from 'react'
import { connect } from 'react-redux'

import TextField from 'material-ui/TextField'
import MenuItem from 'material-ui/MenuItem'
import Moment from 'moment'

import Checkbox from 'material-ui/Checkbox'
import Chip from 'material-ui/Chip'

import dataActions from 'actions/dataActions'

import { doc, dirtyRead, currentDate } from 'selectors/common'
import { propertiesLLEx } from 'selectors/properties'
import { lastPropertyLease } from 'selectors/leases'
import { getMonth, getTimezoneDate } from 'utils/date'

let select = dirtyRead(
	(state, props) => ({
		property: doc(state, props.propertyID)
	  , events: propertiesLLEx(state)[props.propertyID]
  	  , lastPropertyLease: lastPropertyLease(state, props)
  	  , currentDate: currentDate(state)
	})
)

const statuses = ["For Rent", "Not in Service", "Occupied", "Retired"]

export class StatusSelect extends Component{
	render(){
		let { props } = this
		//console.log(props.events);
		return(
			<div style={{width:"10px", position:"absolute", left:"-10px", top:"20px"}}>
				{props.events && props.events.status && props.events.status.forRent!='For Rent' && props.events.status.occupied!='Occupied' && !props.property.dateTill && Moment(props.lastPropertyLease.dateTill)<=Moment(props.currentDate) ?
				<img src="/landlord/static/img/not-in-service.png" alt="status" width="30px"/>

				:props.events && props.events.status && props.events.status.forRent=='For Rent' && !props.property.dateTill ?
					<img src="/landlord/static/img/for-rent.png" alt="status" width="30px"/>

				:props.events && props.events.status && props.events.status.occupied=='Occupied' && !props.property.dateTill &&  props.events.status.notPaying!=='Not Paying' ?
					<img src="/landlord/static/img/occupied-paid.png" alt="status" width="30px"/>

				:props.events && props.events.status && props.events.status.occupied=='Occupied' && !props.property.dateTill &&  props.events.status.notPaying==='Not Paying'  ?
					<img src="/landlord/static/img/occupied-unpaid.png" alt="status" width="30px"/>

				:props.events && props.events.status && props.events.status.contracted=='Contracted' && !props.property.dateTill  ?
					<img src="/landlord/static/img/contracted.png" alt="status" width="30px"/>

				:props.property && props.property.dateTill &&
					<img src="retired.png" alt="status" width="30px"/>
				}
			</div>
		)
	}
}

export default connect(select, dataActions)(StatusSelect)


//<div className="status-select" style={{display:"flex"}}>
//	<div style={{marginTop: "13px"}}>

//	</div>



// WEBPACK FOOTER //
// ./src/routes/landlord/propertyForm/StatusIcons.js